import React from 'react'

import { useTranslation } from 'language/translator'

import Collapse from 'components_new/atoms/Collapse'
import Grid from 'components_new/atoms/Grid'

import CardOption from 'components_new/molecules/CardOption'

import { ISelectMetric, ShowPerEnum } from 'types/GlobalMetric'
import type { Step } from '../lib'

interface Props {
  step: Step
  metric: ISelectMetric
  distribution: ShowPerEnum | null
  setDistribution: (v: ShowPerEnum | null) => void
}

const DistributionStep = ({
  step,
  metric,
  distribution,
  setDistribution
}: Props) => {
  const { t, translateEnum } = useTranslation()

  if (metric.distributions.length === 0) return null

  return (
    <Collapse in={step === 'distribution'}>
      <Grid container={true} spacing={1}>
        <Grid item={true} xs={4}>
          <CardOption
            id={null}
            title={t('global', 'none')}
            active={distribution === null}
            onChange={() => setDistribution(null)}
            sx={{ height: '100%', opacity: 0.5 }}
          />
        </Grid>
        {metric.distributions.map((d) => (
          <Grid item={true} key={d.enum} xs={4}>
            <CardOption
              id={d.enum}
              active={distribution === d.enum}
              title={translateEnum('show_pers', d.enum).abbreviation}
              body={translateEnum('show_pers', d.enum).title}
              onChange={() => setDistribution(d.enum as ShowPerEnum)}
              sx={{ height: '100%' }}
            />
          </Grid>
        ))}
      </Grid>
    </Collapse>
  )
}

export default DistributionStep
